<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="800px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <!-- style="max-height: 720px;overflow-y: auto;padding-right: 20px;" -->
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      label-width="100px">
      <el-form-item label="试题题型：">
        {{ ruleForm.questionType | questionTypeName() }}
      </el-form-item>
      <el-form-item
        label="考试科目："
        prop="subjectId">
        <span v-if="ruleForm.id">{{ ruleForm.subjectName }}</span>
        <subject-select
          v-else
          v-model="ruleForm.subjectId"
          style="width: 100%;" />
      </el-form-item>
      <el-form-item
        label="试题题干："
        prop="questionName">
        <el-input
          v-model="ruleForm.questionName"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4 }"></el-input>
      </el-form-item>
      <el-form-item
        label="题干图片："
        prop="questionContentImages">
        <upload-with-crop
          v-model="ruleForm.questionContentImages"
          :isLt2M="5120"
          :limit="2"
          :autoCropWidth="200"
          :autoCropHeight="100"></upload-with-crop>
      </el-form-item>
      <el-form-item
        label="选项类型："
        prop="choiceType">
        <el-radio-group v-model="ruleForm.choiceType">
          <el-radio :label="1">文本</el-radio>
          <el-radio :label="2">图片</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="试题选项："
        prop="choices">
        <question-choice-item
          v-for="(item, index) in ruleForm.choices"
          :key="item.label"
          v-model="ruleForm.choices[index]"
          :index="index"
          :size="ruleForm.choices.length"
          :choiceType="ruleForm.choiceType"
          @delete="deleteChoice" />
        <el-button
          type="text"
          :disabled="ruleForm.choices.length === 6"
          @click="addChoiceItem">+增加选项</el-button>
      </el-form-item>
      <el-form-item
        label="标准答案："
        prop="answer">
        <el-radio-group v-model="ruleForm.answer">
          <el-radio
            v-for="(item,index) in answerList"
            :key="index"
            :label="item">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="试题难度："
        prop="questionDifficulty">
        <el-rate
          v-model="ruleForm.questionDifficulty"
          style="margin-top: 6px;"
          :max="3"
          show-text
          :texts="texts"></el-rate>
      </el-form-item>
      <el-form-item
        label="试题状态："
        prop="status">
        <el-radio-group v-model="ruleForm.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="9">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import UploadWithCrop from '../../../../components/public/upload-with-crop.vue'
import { difficultyTexts, pushChoices } from '../../index'
import SubjectSelect from '../../subject-select.vue'
import QuestionChoiceItem from './question-choice-item.vue'
export default {
  name: 'ExaminationQuestionModal',
  components: { UploadWithCrop, QuestionChoiceItem, SubjectSelect },
  props: {
    callback: { type: Function, default() {} }
  },
  data() {
    return {
      loading: false,
      visible: false,
      texts: difficultyTexts,
      ruleForm: {
        id: null, subjectId: null, subjectName: '', questionName: '', questionContentImages: [], questionType: 1, questionDifficulty: 1, status: 1, choiceType: 1, answer: null, choices: []
      },
      rules: {
        subjectId: [
          { required: true, message: '请选择考试科目', trigger: 'change' }
        ],
        questionName: [
          { required: true, message: '请输入试题题干', trigger: 'blur' }
        ],
        answer: [
          { required: true, message: '请选择标准答案', trigger: 'change' }
        ],
        choices: [
          { required: true, message: '请填写试题选项', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            const choiceType = this.ruleForm.choiceType
            if (value.some(i => !i.labelDisplay || (choiceType === 1 && !i.content) || choiceType === 2 && !i.contentImage.length === 0)) {
              callback(new Error('请填写完整的试题选项'))
            } else {
              callback()
            }
          }, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.id ? '编辑' : '新增') + '试题'
    },
    answerList({ ruleForm }) {
      return ruleForm.choices.map(i => i.label)
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
      setTimeout(() => {
        this.$refs.ruleForm && this.$refs.ruleForm.clearValidate()
      }, 20)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { choiceType, answer, id, choices, questionContentImages } = this.ruleForm
          const dispatch = id ? 'updateexamquestion' : 'addexamquestion'
          const postChoices = choices.map(item => {
            const { content, label, contentImage } = item
            return {
              ...item, contentInputType: choiceType, isAnswer: +(answer === label), content: choiceType === 2 ? this.$stringfyImage(contentImage) : content, contentImage: null
            }
          })
          this.$$examApi[dispatch]({ ...this.ruleForm, questionContentImages: this.$stringfyImage(questionContentImages), choices: postChoices, answer: null, choiceType: null })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.visible = false
                this.$message.success((id ? '更新' : '新增') + '成功')
                this.callback && this.callback()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    addChoiceItem() {
      this.ruleForm.choices.push(...pushChoices(1, this.ruleForm.choices.length))
    },
    deleteChoice(index) {
      this.ruleForm.choices.splice(index, 1)
    },
    init(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      if (!options.id) {
        this.ruleForm.choices.push(...pushChoices(options.questionType === 1 ? 4 : 2, 0))
      }
      this.visible = true
    }
  }
}
</script>
